export default __webpack_public_path__ + "images/fc0434092520b93b388d383e1f1f9180-promoted-preview.png";